/* Clear Path redesign — flip tiles, size tabs, signup forms, email popup */
(function () {
  var LS = 'cpm_popup', TEASER = 'cpm_teaser_hidden', FORM = 'cpm_form', SNOOZE = 3 * 864e5;
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }

  function initFlips(root) {
    root.querySelectorAll('[data-cpm-flip]').forEach(function (tile) {
      if (tile.dataset.cpmReady) return;
      tile.dataset.cpmReady = '1';
      var btn = tile.querySelector('.cpm-flipbtn');
      var label = btn ? btn.querySelector('span') : null;
      function set(on) {
        tile.classList.toggle('is-flipped', on);
        if (label) label.textContent = on ? tile.dataset.l2 : tile.dataset.l1;
      }
      var hover = window.matchMedia('(hover: hover)').matches;
      if (hover) {
        tile.addEventListener('mouseenter', function () { set(true); });
        tile.addEventListener('mouseleave', function () { set(false); });
      }
      var toggle = function (e) { e.preventDefault(); e.stopPropagation(); set(!tile.classList.contains('is-flipped')); };
      if (btn) btn.addEventListener('click', toggle);
      if (tile.tagName === 'BUTTON') tile.addEventListener('click', toggle);
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-cpm-tabs]').forEach(function (wrap) {
      if (wrap.dataset.cpmReady) return;
      wrap.dataset.cpmReady = '1';
      var tabs = wrap.querySelectorAll('[role=tab]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) { o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
          wrap.querySelectorAll('.cpm-chart').forEach(function (c) { c.hidden = c.id !== t.getAttribute('aria-controls'); });
        });
      });
    });
  }

  // Native Shopify customer forms: remember which one was sent; after Shopify redirects back
  // with ?customer_posted=true, show the success message on that form only.
  function initForms(root) {
    root.querySelectorAll('form[data-cpm-key]').forEach(function (f) {
      if (f.dataset.cpmReady) return;
      f.dataset.cpmReady = '1';
      f.addEventListener('submit', function () { ss(FORM, f.dataset.cpmKey); });
    });
    var posted = /[?&]customer_posted=true/.test(location.search);
    var key = ss(FORM);
    // Shopify renders errors into every customer form; keep them only on the form that was sent.
    root.querySelectorAll('.cpm-err').forEach(function (e) {
      var host = e.closest('[data-cpm-errfor]');
      if (!key || !host || host.dataset.cpmErrfor !== key) e.remove();
    });
    if (posted && key) {
      var f = root.querySelector('form[data-cpm-key="' + key + '"]');
      if (f) {
        var msg = document.createElement('div');
        msg.className = 'cpm-ok-msg';
        msg.setAttribute('role', 'status');
        msg.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
        msg.querySelector('span').textContent = f.dataset.cpmOk || "You're in.";
        f.replaceWith(msg);
        ls(LS, 'joined');
        ss(FORM, null);
        return key;
      }
    }
    return null;
  }

  function initPopup(postedKey) {
    var pop = document.getElementById('cpm-pop');
    var teaser = document.getElementById('cpm-teaser');
    if (!pop || !teaser) return;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      teaser.hidden = true; pop.hidden = false;
      var i = pop.querySelector('input[type=email]') || pop.querySelector('.cpm-x');
      if (i) setTimeout(function () { i.focus(); }, 50);
    }
    function close() {
      pop.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      if (ls(LS) === 'joined') return;
      ls(LS, String(Date.now()));
      if (ss(TEASER) !== '1') teaser.hidden = false;
    }
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    pop.querySelectorAll('[data-cpm-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    teaser.querySelector('.cpm-teaser__open').addEventListener('click', open);
    teaser.querySelector('.cpm-teaser__x').addEventListener('click', function () { teaser.hidden = true; ss(TEASER, '1'); });

    if (postedKey === 'popup' || pop.querySelector('.cpm-err')) { open(); return; }
    var saved = ls(LS);
    if (saved === 'joined') return;
    if (/[?&]popup\b/.test(location.search)) { open(); return; }
    if (saved && Date.now() - Number(saved) < SNOOZE) { if (ss(TEASER) !== '1') teaser.hidden = false; return; }

    // Phones: never auto-open over shopping pages; on the homepage wait longer and skip the scroll trigger.
    var phone = window.matchMedia('(max-width: 999px)').matches;
    var home = !!document.querySelector('.cpm-hero');
    if (phone && !home) { if (ss(TEASER) !== '1') teaser.hidden = false; return; }
    var shown = false, timer;
    function busy() { return !!document.querySelector('cart-drawer[open], quick-buy-drawer[open], x-drawer[open], dialog[open], [id^=product-quick-buy][open]'); }
    function show() { if (shown) return; if (busy()) { timer = setTimeout(show, 4000); return; } shown = true; cleanup(); open(); }
    function onScroll() { var max = document.documentElement.scrollHeight - innerHeight; if (max > 0 && scrollY / max > 0.4) show(); }
    function onLeave(e) { if (e.clientY <= 0) show(); }
    function cleanup() { clearTimeout(timer); removeEventListener('scroll', onScroll); document.removeEventListener('mouseleave', onLeave); }
    timer = setTimeout(show, phone ? 20000 : 8000);
    if (!phone) addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseleave', onLeave);
  }

  // Hide the early-access tab while the cart or a size picker is open so it never covers Checkout / Add to cart.
  function watchDrawers() {
    var sel = 'cart-drawer[open], quick-buy-drawer[open], x-drawer[open], dialog[open], [id^=product-quick-buy][open]';
    var sync = function () { document.documentElement.classList.toggle('cpm-drawer-open', !!document.querySelector(sel)); };
    new MutationObserver(sync).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    sync();
  }

  function boot() {
    try { watchDrawers(); } catch (e) {}
    initFlips(document); initTabs(document);
    var key = initForms(document);
    initPopup(key);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initFlips(e.target); initTabs(e.target); initForms(e.target); });
})();
